import { useState } from "react";
import { redirect } from "react-router-dom";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch("https://drpatangecitydentalclinic.com/api/login.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      const data = await res.json();

   if (data.status === "success") {
  localStorage.setItem("isAdmin", "true");
  navigate("/admin/dashboard");
} else {
        alert("Invalid Login");
      }
    } catch (error) {
      alert("Server Error");
    }

    setLoading(false);
  };

  return (
    <div className="container-fluid vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="row w-100">
        <div className="col-md-4 mx-auto">

          <div className="card shadow-lg border-0 rounded-4">
            
            <div className="card-header text-center bg-primary text-white rounded-top-4 py-4">
              <p className="mb-0 text-white">City Dental</p>
              <small>Admin Login</small>
            </div>

            <div className="card-body p-4">

              <form onSubmit={handleLogin}>
                
                <div className="mb-3">
                  <label className="form-label">Username</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter username"
                    onChange={(e) => setUsername(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Enter password"
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-primary w-100 py-2"
                  disabled={loading}
                >
                  {loading ? "Logging in..." : "Login"}
                </button>

              </form>

            </div>

            <div className="card-footer text-center text-muted small">
              © City Dental Clinic Admin Panel
            </div>

          </div>

        </div>
      </div>
    </div>
  );
}